import Axios from 'axios';
import { API } from 'core/api';
import { useQuery } from 'react-query';
import {
  IncidentAnalyticsByService,
  IncidentMetricsForService,
} from '../types/service-detail.types';
import { queryKeys, reactQueryConfig } from '../contants/service.contant';
import { reactQueryConfigError } from '../helpers/helper.service';

import { AppConfig } from 'shared/app.config';

const getIncidentMetricsForService = async (serviceIds: string[], owner_id: string) => {
  const { data } = await Axios.get<IncidentMetricsForService>(
    `${AppConfig.api_url}/v3/organizations/${API.config.organizationId}/catalog-services/metrics/incident-metrics`,
    {
      params: {
        serviceID: serviceIds,
        owner_id,
      },
    },
  );
  return data;
};

const getIncidentAnalyticsByService = async (serviceId: string) => {
  const { data } = await Axios.get<IncidentAnalyticsByService>(
    `${AppConfig.api_url}/v3/organizations/${API.config.organizationId}/catalog-services/${serviceId}/metrics/incident-metrics`,
  );
  return data;
};

export const useIncidentMetricsForService = (serviceIds: string[], teamId: string) => {
  return useQuery({
    queryKey: [queryKeys.INCIDENTMETRICSFORSERVICE, serviceIds, teamId],
    queryFn: () => getIncidentMetricsForService(serviceIds, teamId),
    ...reactQueryConfig,
    enabled: !!teamId && !!serviceIds.length,
    select: res => res.data,
    onError: reactQueryConfigError,
  });
};

export const useIncidentAnalyticsByService = (serviceId: string) => {
  return useQuery({
    queryKey: [queryKeys.INCIDENTANALYTICSBYSERVICE, serviceId],
    queryFn: () => getIncidentAnalyticsByService(serviceId),
    ...reactQueryConfig,
    enabled: !!serviceId,
    select: res => res,
    onError: reactQueryConfigError,
  });
};
